export enum Panel {
  FEED_CHAT = 'feed-chat',
  MEMBERS = 'members',
}
